import React , { useEffect, useState } from 'react';
import Layout from "../../../components/mobile/Layout/layoutmobile";
import { navigate } from "gatsby";
import { pushtracking } from '../../../service/trackingService';
import { useLocation } from '@reach/router';

const DKHoantien=()=> {
    const location = useLocation();
    const [meta, setMeta] = useState([]);
    useEffect(() => {
      try{
        pushtracking(window.localStorage.getItem('sessionId')??null,
        window.localStorage.getItem('_id')??null,
        window.localStorage.getItem('phone')??null ,
        location.pathname, "Giới thiệu về Bibo Mart", 0,0,'index','inWeb',[],'Website PC').then((response)=>{
            // console.log('send tracking');
        });
      }catch(e){console.log(e)}
    },[])

    const Handleclick =()=>{
        window.history.back();
    }
  return (
   <Layout>
        <style jsx>{`
           .child-ul{
            list-style-type: circle;
            margin-left:10px;
           }
           .title{
            padding-top:20px;
           }
        `}</style>
        <div className="container">
            <div className="header row d-flex pdy-10 mgx-0 mgt-10">
                <div className="col-1 in-f" onClick={Handleclick}>
                    <i className="fa-solid fa fa-chevron-left"></i>
                </div>
                <div className="col-10 flex-center">
                    <span className="text_14 font_700"> ĐIỀU KHOẢN HOÀN TIỀN</span>
                </div>
                <div className="col-1"></div>
            </div>
            <div className='container page-builder-ltr'>
            <div className='container-page-footer mt-4'>
                <p
                   
                >
                    <b>Điều 1: Phạm vi áp dụng</b>
                </p>
                <ol  start={1} type={1}>
                    <li
                   
                    >
                    Điều khoản này áp dụng cho tất cả các giao dịch hoàn tiền do{" "}
                    <b>Công ty cổ phần Bibomart TM</b> thực hiện, bao gồm các trường hợp hoàn
                    tiền do lỗi sản phẩm, hủy giao dịch, hoặc các trường hợp đặc biệt khác
                    được quy định cụ thể trong chính sách của Công ty.
                    <br />
                    <br />
                    </li>
                </ol>
                <p>
                    <b>Điều 2: Điều kiện hoàn tiền</b>
                </p>
                <ol start={1} type={1}>
                    <li>
                    Khách hàng được xem xét hoàn tiền nếu đáp ứng các điều kiện sau:
                    </li>
                        <ul className='child-ul'>
                        <li>
                            Cung cấp đầy đủ thông tin tài khoản ngân hàng chính xác
                        </li>
                        <li>
                            Có đầy đủ hóa đơn, chứng từ hoặc biên nhận giao dịch liên quan
                        </li>
                        <li>
                            Yêu cầu hoàn tiền nằm trong thời gian quy định (nếu có)
                        </li>
                        </ul>
                    <li    >
                    Trường hợp không đủ điều kiện, Công ty có quyền từ chối hoàn tiền và sẽ
                    thông báo cụ thể lý do.
                    <br />
                    <br />
                    </li>
                </ol>
                <p>
                    <b>Điều 3: Phương thức và thời gian hoàn tiền</b>
                </p>
                <ol style={{ marginTop: "0in" }} start={1} type={1}>
                    <li    >
                    Khoản tiền sẽ được hoàn trả qua hình thức chuyển khoản ngân hàng hoặc
                    phương thức tương ứng với hình thức thanh toán ban đầu của Khách hàng.
                    </li>
                    <li    >
                    Thời gian xử lý hoàn tiền: Trong vòng 2 ngày làm việc kể từ khi nhận đủ
                    thông tin và hồ sơ hợp lệ.
                    <br />
                    <br />
                    </li>
                </ol>
                <p>
                    <b>Điều 4: Phí hoàn tiền</b>
                </p>
                <ol style={{ marginTop: "0in" }} start={1} type={1}>
                    <li    >
                    Các khoản phí liên quan đến giao dịch hoàn tiền (nếu có) sẽ được thông báo
                    trước khi thực hiện.
                    </li>
                    <li    >
                    Trường hợp phát sinh phí giao dịch ngân hàng, khách hàng chịu trách nhiệm
                    thanh toán khoản phí này (trừ khi lỗi từ phía Công ty).
                    <br />
                    <br />
                    </li>
                </ol>
                <p>
                    <b>Điều 5: Quyền và nghĩa vụ của các bên</b>
                </p>
                <ol style={{ marginTop: "0in" }} start={1} type={1}>
                    <li    >
                    <b>Công ty</b>:
                    </li>
                    <ul className='child-ul'>
                    <li
                       
                        
                    >
                        Chịu trách nhiệm xử lý và thực hiện hoàn tiền đúng hạn khi Khách hàng đủ
                        điều kiện nhận hoàn tiền.
                    </li>
                    <li
                       
                        
                    >
                        Cam kết bảo mật thông tin khách hàng theo chính sách bảo mật thông tin
                        cá nhân của Công ty.
                    </li>
                    </ul>
                    <li    >
                    <b>Khách hàng</b>:
                    </li>
                    <ul className='child-ul'>
                    <li
                       
                        
                    >
                        Cung cấp đầy đủ và chính xác thông tin cần thiết để thực hiện hoàn tiền.
                    </li>
                    <li
                       
                        
                    >
                        Không yêu cầu bồi thường thêm ngoài khoản tiền hoàn trả (trừ khi có quy
                        định khác).
                        <br />
                        <br />
                    </li>
                    </ul>
                </ol>
                <p>
                    <b>Điều 6: Cam kết chịu trách nhiệm và không khiếu nại</b>
                </p>
                <ol style={{ marginTop: "0in" }} start={1} type={1}>
                    <li    >
                    Khách hàng cam kết rằng tất cả thông tin cung cấp để thực hiện giao dịch
                    hoàn tiền là trung thực, chính xác và đầy đủ.
                    </li>
                    <li    >
                    Sau khi nhận được khoản tiền hoàn trả từ Công ty, Khách hàng xác nhận và
                    đồng ý rằng:
                    </li>
                    <ul className='child-ul'>
                    <li
                       
                        
                    >
                        Không tiếp tục yêu cầu thêm bất kỳ khoản bồi thường hay hoàn tiền nào
                        khác liên quan đến giao dịch đã xử lý.
                    </li>
                    <li
                       
                        
                    >
                        Không có khiếu nại, tranh chấp hoặc khởi kiện nào liên quan đến giao
                        dịch hoàn tiền này, trừ trường hợp Công ty không thực hiện đúng các cam
                        kết được quy định trong điều khoản.
                    </li>
                    </ul>
                    <li    >
                    Công ty không chịu trách nhiệm với các trường hợp khách hàng cung cấp sai
                    thông tin dẫn đến giao dịch không thành công hoặc phát sinh vấn đề ngoài
                    tầm kiểm soát của Công ty.
                    <br />
                    <br />
                    </li>
                </ol>
                <p>
                    <b>Điều 7: Các trường hợp bất khả kháng</b>
                    <br />
                    Công ty không chịu trách nhiệm hoàn tiền chậm trễ hoặc không thực hiện được
                    trong các trường hợp bất khả kháng như thiên tai, lỗi hệ thống ngân hàng,
                    hoặc các sự cố ngoài ý muốn.
                    <br />
                    <br />
                </p>
                <p>
                    <b>Điều 8: Hiệu lực và sửa đổi</b>
                </p>
                <ol style={{ marginTop: "0in" }} start={1} type={1}>
                    <li    >
                    Điều khoản này có hiệu lực từ ngày 18/01/2025.
                    </li>
                    <li    >
                    Công ty có quyền sửa đổi, bổ sung điều khoản hoàn tiền và sẽ không cần thông báo trước đến khách hàng.
                    </li>
                </ol>
                <p>
                    <b>Điều 9: Liên hệ hỗ trợ</b>
                    <br />
                    Mọi thắc mắc hoặc khiếu nại liên quan đến hoàn tiền, vui lòng liên hệ:
                </p>
                <ul style={{ marginTop: "0in" }} type="disc">
                    <li    >
                    Hotline: 1800 6886
                    </li>
                    <li    >
                    Email:{" "}
                    <span
                    >
                        cskh@bibomart.com.vn
                    </span>
                    </li>
                </ul>
                </div>


            </div>
        </div>
   </Layout>
  )
}
export default DKHoantien;